<style lang="scss">
.el-card__body {
    padding: 10px 0 10px 10px!important;
}

.item-button-div {
    height: 40px;
}
.item-add-button {
    float: right;
}


.item-row-card {
    margin-bottom: 15px;

    .item-img {
        height: 200px;
        width: 200px;
    }
}
.number-info-row {
    margin-bottom: 10px;
}



.item-sku-div {
    overflow-x: hidden;
    overflow-y: auto;

    .item-sku-title {
        float: left;
    }

    .item-sku-add {
        float: left;
    }

    .item-sku {
        float: left;
        .item-size {
            width: 80px;
        }
        .item-num {
            width: 60px;
        }
    }
}

.el-item-add {
    cursor: pointer;
}

.item-save-buttom-div {
    .el-button {
        float: right;
        margin: 10px 10px 0 0;
    }
}

.item-delete{
    position: absolute;
    top: -11px;
    right: -1px;
    cursor: pointer;
}

.item-number-save {
    float: right;
}

.number-row {
    .el-tag + .el-tag {
        margin-left: 10px;
        margin-bottom: 5px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
}

.number-table {
    font-size: 10px;

    .cell {
        line-height: 22px!important;
    }

    td, th {
        padding: 0;
    }
    
    .input-number {
       line-height: 20px;

        .el-input__inner {
            height: 20px!important;
            width: 100px;
        }
        
    }
}

.item-remark {
    height: 160px;
    overflow: auto;
    margin: 0;
    font-size: 14px;
    line-height: 18px;

    pre {

    }
}

.item-info-div{
    height: 22px;
}

.orderItemForm {
    .el-form-item {
        margin: 0;
    }
}

.buyer-select {
    td, th {
        padding: 2px 0;
    }
}

.item-row {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 410px;
    width: 620px;

    .item-card {
        width: 600px;
        height: 400px;
        margin-bottom: 15px;

        .item-card-content {
            height: 280px;
            overflow-x: hidden;
            overflow-y: auto;
        }

        .item-img {
            height: 200px;
            width: 200px;
        }

        .item-info-one {
            width: 323px;

            input {
                height: 35px;
            }
        }

        .item-info-two {
            width: 138px;
            
            input {
                height: 35px;
            }
        }
    }
    
}

.item-export-button {
    float: right;
    margin-top: -25px;
}
</style>

<template>
    <div>
        <el-dialog
            :title="title"
            :width="width + 'px'"
            :visible.sync="showDialog"
            @closed="refeshRule"
            class="order-add-dialog"
        >
            <el-form
                ref="orderForm"
                label-width="120px"
                :model="order"
                :rules="rules"
                v-if="step == 'b' || step == 'a'"
            >
                <el-form-item label="生产单类型" prop="type">
                    <el-select v-model="order.type" placeholder="请选择生产单类型" style="width: 100%">
                        <el-option
                            v-for="item in types"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="关联订单" prop="alibabaOrder">
                    <el-input v-model="order.alibabaOrder" style="width:305px;margin-right:5px;"></el-input>

                    <el-popover  placement="bottom-end" title="选择订单" width="450" trigger="click" v-model="visibleAlibabaOrders">
                        <el-link slot="reference" type="primary" :underline="false" @click="getAlibabaOrder">选择</el-link>

                        <el-table class="buyer-select" :data="alibabaOrders">
                            <el-table-column property="id" width="45">
                                <template slot-scope="scope">
                                    <el-checkbox @change="seleteAlibabaOrders(scope.row)" v-model="checkedAlibabaOrders"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column width="200" property="id" label="订单编号">
                                <template slot="header" slot-scope="scope">
                                    <el-input v-model="alibabaOrdersParams.id" size="mini" @keyup.enter.native="getAlibabaOrder" placeholder="输入订单编号"/>
                                </template>

                                <template slot-scope="order">{{order.row.id}}
                                    <el-tag type="danger" v-if="order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                                    <el-tag type="ssuccess" v-if="order.row.isShippingFee == 'Y'">运</el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column prop="sellerName" label="销售员" width="100"></el-table-column>

                            <el-table-column width="200" property="buyerName" label="客户名称">
                                <template slot="header" slot-scope="scope">
                                    <el-input v-model="alibabaOrdersParams.buyerStr" size="mini" @keyup.enter.native="getAlibabaOrder" placeholder="输入客户名称"/>
                                </template>
                            </el-table-column>

                            <el-table-column prop="status" label="订单状态" width="100"></el-table-column>

                            <el-table-column prop="totalAmount" label="订单金额($)" width="100">
                                <template slot-scope="order">{{ $tools.parsecost(order.row.totalAmount, true)}}</template>
                            </el-table-column>

                            <el-table-column prop="createDate" label="下单时间" width="160">
                                <template slot-scope="order">{{ $tools.timestampToTime(order.row.createDate)}}</template>
                            </el-table-column>
                        </el-table>

                        <el-pagination
                            small
                            layout="total, prev, pager, next"
                            :total="alibabaOrdersParams.total"
                            @current-change="getAlibabaOrder"
                            :current-page.sync="alibabaOrdersParams.current"
                        ></el-pagination>
                    </el-popover>
                </el-form-item>

                <el-form-item label="客户名称" prop="fullName">
                    <el-input v-model="order.fullName" style="width:305px;margin-right:5px;"></el-input>

                    <el-popover  placement="bottom-end" title="选择客户" width="450" trigger="click" v-model="visibleBuyer">
                        <el-link slot="reference" type="primary" :underline="false" @click="pageBuyer">选择</el-link>

                        <el-table class="buyer-select" :data="buyers">
                            <el-table-column property="id" width="45">
                                <template slot-scope="scope">
                                    <el-checkbox @change="seleteBuyer(scope.row)" v-model="checkedBuyer"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column width="200" property="fullName" label="名称">
                                <template slot="header" slot-scope="scope">
                                    <el-input v-model="buyerParams.fullName" size="mini" @keyup.enter.native="pageBuyer" placeholder="输入客户名称"/>
                                </template>
                            </el-table-column>
                            <el-table-column width="200" property="companyName" label="公司">
                                <template slot="header" slot-scope="scope">
                                    <el-input v-model="buyerParams.companyName" size="mini" @keyup.enter.native="pageBuyer" placeholder="输入公司名称"/>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-pagination
                            small
                            layout="total, prev, pager, next"
                            :total="buyerParams.total"
                            @current-change="pageBuyer"
                            :current-page.sync="buyerParams.current"
                        ></el-pagination>

                    </el-popover>
                </el-form-item>

                <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="order.companyName"></el-input>
                </el-form-item>

                <el-form-item label="期望交付日期" prop="deliveryTime">
                    <el-date-picker
                        type="date"
                        placeholder="期望交付日期"
                        v-model="order.deliveryTime"
                        style="width: 100%"
                    ></el-date-picker>
                </el-form-item>
            </el-form>

            <el-form ref="orderItemForm" class="orderItemForm" label-width="40px" :model="order" v-if="step == 'c' || step == 'd' || step == 'm'">
                <div class="item-button-div">
                    <el-row>
                        <el-col :span="7">{{ orderItems.length }} 个明细</el-col>
                        <el-col :span="7">共 {{getSkuTotal()}} 件</el-col>
                        <el-col :span="7" v-if="isRoot">共计 {{getSkuCost()}} 元</el-col>
                        <el-col :span="3" v-if="step == 'c'">
                            <el-button 
                                class="item-add-button"
                                type="success"
                                plain
                                icon="el-icon-plus"
                                size="small"
                                title="新增"
                                @click="addEmptyItem"
                                v-if="!orderItem"
                            ></el-button>
                        </el-col>
                        <el-col v-else>
                            <el-button type="primary" size="small" class="item-export-button" @click="exportItem">导出</el-button>
                        </el-col>
                    </el-row>

                </div>

                <div class="item-row">
                    <el-card class="item-card" v-for="(item, key) in orderItems" :key="key">
                        <el-tabs :value="tabActive[item.id] || defTabActive">
                            <el-tab-pane label="基本信息" name="1"> 
                                <div class="item-card-content">
                                    <el-row>
                                        <el-col :span="9">
                                            <sn-file-upload v-if="canSave(item)"
                                                relateType="FactoryOrderItem"
                                                title="上传主图"
                                                :imgModel="true"
                                                :showList="false"
                                                imgSize="180-180"
                                                :uploadedCallback="uploadedCallbackMainImg"
                                                :progressCallback="progressCallback"
                                                :beforeUpload="uploadedCallbackMainImg"
                                            >
                                                <template>
                                                    <img class="item-img" v-if="item.mainImg && item.mainImg > 0" :src="'/api/file/download/byId?id=' + item.mainImg"  />
                                                    <img class="item-img" v-else-if="item.mainImgBase || item.percent <= 0"  :src="item.mainImgBase"  />
                                                    <el-progress class="item-img" type="circle" v-else :percentage="item.percent" :width="200"></el-progress>
                                                </template>
                                            </sn-file-upload>
                                            <img v-else class="item-img" :src="'/api/file/download/byId?id=' + item.mainImg"  />
                                        </el-col>

                                        <el-col :span="15">
                                            <el-form-item label="名称">
                                                <el-input class="item-info-one" v-if="canSave(item)" v-model="item.name"></el-input>
                                                <div v-else>{{item.name}}</div>
                                            </el-form-item>

                                            <el-form-item label="型号">
                                                <el-input class="item-info-one" v-if="canSave(item)"  v-model="item.code"></el-input>
                                                <div v-else>{{item.code}}</div>
                                            </el-form-item>

                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="材质">
                                                        <el-input class="item-info-two"  v-if="canSave(item)" v-model="item.material"></el-input>
                                                        <div v-else>{{item.material}}</div>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="单位">
                                                        <el-select class="item-info-two"  v-if="canSave(item)" v-model="item.unit">
                                                            <el-option v-for="item in units" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                                                        </el-select>

                                                        <div v-else>{{getUnitName(item.unit)}}</div>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <el-form-item label="备注">
                                                <el-input class="item-remark item-info-one" v-if="canSave(item)" type="textarea" :rows="7" v-model="item.remark"></el-input>
                                                <pre v-else class="item-remark">{{item.remark}}</pre>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="包装信息" name="2">
                                <div class="item-card-content">
                                    <el-row>
                                        <el-col :span="9">
                                            <sn-file-upload v-if="canSave(item)"
                                                relateType="FactoryOrderItem"
                                                title="上传包装图"
                                                :imgModel="true"
                                                :showList="false"
                                                imgSize="180-180"
                                                :uploadedCallback="uploadedCallbackPackImg"
                                                :progressCallback="progressCallback"
                                                :beforeUpload="uploadedCallbackPackImg"
                                            >
                                                <template>
                                                    <img class="item-img" v-if="item.packImg && item.packImg > 0" :src="'/api/file/download/byId?id=' + item.packImg"  />
                                                    <img class="item-img" v-else-if="item.packImgBase || item.percent <= 0"  :src="item.packImgBase"  />
                                                    <el-progress class="item-img" type="circle" v-else :percentage="item.percent" :width="200"></el-progress>
                                                </template>
                                            </sn-file-upload>
                                            <img v-else class="item-img" :src="'/api/file/download/byId?id=' + item.packImg"  />
                                        </el-col>
                                        <el-col :span="15">
                                            <el-form-item label="要求">
                                                <el-input class="item-remark item-info-one" v-if="canSave(item)" type="textarea" :rows="7" v-model="item.pack"></el-input>
                                                <pre v-else class="item-remark">{{item.pack}}</pre>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="商标信息" name="3">
                                <div class="item-card-content">
                                    <div class="item-card-content">
                                        <el-row>
                                            <el-col :span="9">
                                                <sn-file-upload v-if="canSave(item)"
                                                    relateType="FactoryOrderItem"
                                                    title="上传标图"
                                                    :imgModel="true"
                                                    :showList="false"
                                                    imgSize="180-180"
                                                    :uploadedCallback="uploadedCallbackTrademarkImg"
                                                    :progressCallback="progressCallback"
                                                    :beforeUpload="uploadedCallbackTrademarkImg"
                                                >
                                                    <template>
                                                        <img class="item-img" v-if="item.trademarkImg && item.trademarkImg > 0" :src="'/api/file/download/byId?id=' + item.trademarkImg"  />
                                                        <img class="item-img" v-else-if="item.trademarkImgBase || item.percent <= 0" :src="item.trademarkImgBase"  />
                                                        <el-progress class="item-img" type="circle" v-else :percentage="item.percent" :width="200"></el-progress>
                                                    </template>
                                                </sn-file-upload>
                                                <img v-else class="item-img" :src="'/api/file/download/byId?id=' + item.trademarkImg"  />
                                            </el-col>
                                            <el-col :span="15">
                                                <el-form-item label="要求">
                                                    <el-input class="item-remark item-info-one" v-if="canSave(item)" type="textarea" :rows="7" v-model="item.trademark"></el-input>
                                                    <pre v-else class="item-remark">{{item.trademark}}</pre>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="数量价格" name="4">
                                <div class="item-card-content">
                                    <el-table :data="item.numbers" class="number-table" border stripe :span-method="colorSpanMethod">
                                        <el-table-column prop="color" label="颜色" width="120">
                                            <template slot="header" slot-scope="scope">
                                                颜色<el-popover  placement="bottom-start" title="颜色" width="400" trigger="click" v-if="canSave(item)">
                                                    <i slot="reference" class="el-icon-plus el-item-add"></i>
                                                    <div>
                                                        <el-row class="number-row">
                                                            <el-tag :key="color" v-for="color in item.colors" closable :disable-transitions="false" @close="handleColorClose(item, color)">{{color}}</el-tag>

                                                            <el-input class="input-new-tag" v-if="colorVisible" v-model="colorValue" :ref="'color-' + item.id" size="small" @keyup.enter.native="handleColorConfirm(item)" @blur="handleColorConfirm(item)"></el-input>
                                                            <el-button v-else class="button-new-tag" size="small" @click="showColorInput(item)"> + 新增</el-button>
                                                        </el-row>
                                                    </div>
                                                </el-popover>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="size" label="尺寸" width="120">
                                            <template slot="header" slot-scope="scope">
                                                尺寸<el-popover placement="bottom-start" title="尺寸" width="400" trigger="click" v-if="canSave(item)">
                                                    <i slot="reference" class="el-icon-plus el-item-add"></i>
                                                    <div>
                                                        <el-row class="number-row">
                                                            <el-tag :key="size" v-for="size in item.sizes" closable :disable-transitions="false" @close="handleSizeClose(item, size)">{{size}}</el-tag>

                                                            <el-input class="input-new-tag" v-if="sizeVisible" v-model="sizeValue" :ref="'size-' + item.id" size="small" @keyup.enter.native="handleSizeConfirm(item)" @blur="handleSizeConfirm(item)"></el-input>
                                                            <el-button v-else class="button-new-tag" size="small" @click="showSizeInput(item)"> + 新增</el-button>
                                                        </el-row>
                                                    </div>
                                                </el-popover>
                                            </template>
                                        </el-table-column>

                                        <el-table-column  label="总数" width="120">
                                            <template slot-scope="scope">
                                                <el-input-number v-if="canSave(item)" class="input-number" :controls="false" :precision="0" v-model="scope.row.number"></el-input-number>
                                                <span v-else>{{scope.row.number}}</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="报价￥" width="120" v-if="isRoot">
                                            <template slot-scope="scope">
                                                <span  v-if="canSaveCost(item)">
                                                    <el-input-number class="input-number" :controls="false" :precision="2" v-model="scope.row.cost"></el-input-number>
                                                </span>
                                                <span v-else>{{scope.row.cost ? scope.row.cost : 0}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="'其他文件(' + (item.files ? item.files.length : 0) + ')'" name="5">
                                <div class="item-card-content">
                                    <sn-file-upload :disabled="!canSave(item)" relateType="FactoryOrderItem" :relateId="item.id" :files.sync="item.files" :userId="$cookies.get('U_ID')" title="上传附件"></sn-file-upload>
                                </div>
                            </el-tab-pane>
                        </el-tabs>

                        <div class="item-save-buttom-div" v-if="step == 'c'">
                            <el-button type="primary" size="mini" @click="preSaveItem" v-if="canSave(item)">保存</el-button>
                            <el-button type="primary" size="mini" @click="saveProgress" v-if="(!item.id || (orderItem && item.id ==orderItem.id)) && step == 'f'">保存</el-button>
                            <el-button size="mini" @click="cancelSeveItem" v-if="item.id && (orderItem && item.id == orderItem.id)">取消</el-button>
                            <el-button type="primary" size="mini"  @click="editItem(item)" v-if="item.id && !orderItem">编辑</el-button>
                            <el-button type="danger" size="mini" @click="delItem(item)" v-if="(!orderItem || item.id == orderItem.id) && step == 'c'">删除</el-button>
                        </div>

                        <div class="item-save-buttom-div" v-else-if="step == 'm'">
                            <el-button type="primary" size="mini" @click="preSaveItemCost" v-if="item.id && (orderItem && item.id == orderItem.id)">保存</el-button>
                            <el-button size="mini" @click="cancelSeveItem" v-if="item.id && (orderItem && item.id == orderItem.id)">取消</el-button>
                            <el-button type="primary" size="mini"  @click="editItem(item)" v-if="item.id && !orderItem">编辑</el-button>
                        </div>
                    </el-card>
                </div>
            </el-form>

            <el-form  ref="supplierForm"  v-if="step == 'e'" label-width="60px">
                <el-form-item label="供应商" prop="supplier">
                    <el-select v-model="order.supplier" placeholder="请选择供应商" style="width: 100%">
                        <el-option
                            v-for="item in suppliers"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            :disabled="item.status != 'Y'"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <el-form ref="planDeliveryForm" v-if="step == 'g'" label-width="100px">
                <el-form-item label="计划交付日期" prop="planDeliveryTime">
                    <el-date-picker type="date" placeholder="计划交付日期" v-model="order.planDeliveryTime" style="width: 100%"></el-date-picker>
                </el-form-item>
            </el-form>

            <el-form ref="productStatusForm" v-if="step == 'f'" label-width="60px">
                <el-form-item label="状态">
                    <el-select v-model="order.productStatus" placeholder="请选生产状态">
                        <el-option
                            v-for="item in productStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="order.remark"></el-input>
                </el-form-item>
            </el-form>

            <el-form ref="paymentForm" v-if="step == 'k' || step == 'l'" label-width="80px" label-position="left" :rules="paymentRules" :model="order">
                <el-row style="margin-bottom: 10px;">
                    <el-row><el-col :span="19">首款</el-col><el-col :span="3"><el-link v-if="step == 'k'" type="primary" @click="raltePyment('DOWN')">关联</el-link></el-col></el-row>
                    <el-row>
                        <el-table :data="paymentRelateData1">
                            <el-table-column prop="id" label="关联单号" width="300"></el-table-column>
                            <el-table-column label="金额￥" width="100">
                                <template slot-scope="cost">
                                    {{ $tools.parsecost(cost.row.cost)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="时间" width="160">
                                <template slot-scope="cost">
                                    {{ $tools.timestampToTime(cost.row.time)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80" v-if="step == 'k'" >
                                <template slot-scope="cost">
                                    <el-link type="primary" @click="cancelPayment(orderId, cost.row.id, 'DOWN')">取消关联</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-row>

                <el-row>
                    <el-row><el-col :span="19">尾款</el-col><el-col :span="3"><el-link type="primary" v-if="step == 'k'"  @click="raltePyment('BALANCE')">关联</el-link></el-col></el-row>
                    <el-row>
                        <el-table :data="paymentRelateData2">
                            <el-table-column prop="id" label="关联单号" width="300"></el-table-column>
                            <el-table-column label="金额￥" width="100">
                                <template slot-scope="cost">
                                    {{ $tools.parsecost(cost.row.cost)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="时间" width="160">
                                <template slot-scope="cost">
                                    {{ $tools.timestampToTime(cost.row.time)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80" v-if="step == 'k'">
                                <template slot-scope="cost">
                                    <el-link type="primary" @click="cancelPayment(orderId, cost.row.id, 'BALANCE')">取消关联</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="preSave"
                    v-if="step == 'a'"
                >下一步</el-button>

                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="preSave"
                    v-if="step == 'b'"
                >确认</el-button>

                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="updateSupplier"
                    v-if="step == 'e'"
                >分配</el-button>

                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="toProduct"
                    v-if="step == 'g'"
                >确认排产</el-button>

                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="upProductStatus"
                    v-if="step == 'f'"
                >更新状态</el-button>

                <el-button
                    type="primary"
                    size="small"
                    class="op-button"
                    @click="preSavePayment"
                    v-if="step == 'k'"
                >支付</el-button>
            </div>
        </el-dialog>

        <finance-bill-out-search-dialog :show.sync="showBillDialog" :afterSeleted="afterSeleted" :isMul="false"></finance-bill-out-search-dialog>
    </div>
</template>

<script>
import SnFileUpload from "../components/SnFileUpload.vue";
import FinanceBillOutSearchDialog from './Finance-bill-out-searchDialog.vue';

export default {
    components: { SnFileUpload, FinanceBillOutSearchDialog },
    props: {
        showAdd: { type: Boolean, default: false },
        isRoot: { type: Boolean, default: false },
        actionFuc: { type: Function, default: null },
    },

    data() {
        return {
            productStatus: [
                { id: "INT", name: "未启动" },
                { id: "PUR", name: "采购面料" },
                { id: "ACC", name: "辅料生产" },
                { id: "CUT", name: "裁片" },
                { id: "PRI", name: "印花" },
                { id: "SEW", name: "车缝" },
                { id: "LAB", name: "车标" },
                { id: "THR", name: "剪线头" },
                { id: "IRO", name: "熨烫" },
                { id: "PACK", name: "包装" },
            ],
            paymentStatus: [
                { id: "DOWN", name: "首款" },
                { id: "BALANCE", name: "尾款" }
            ],
            types: [
                { name: "样板", id: "S" },
                { name: "大货", id: "F" },
            ],
            units: [
                { name: "个", id: "O" },
                { name: "包", id: "P" },
            ],
            orderId: null,
            order: {},
            orderItem: {},
            orderItemNumber: [],
            orderItems: [],
            showDialog: false,
            rules: {
                type: [
                    {
                        required: true,
                        message: "请选择生产单类型",
                        trigger: "blur",
                    },
                ],

                fullName: [
                    {
                        min: 2,
                        max: 70,
                        message: "长度在 2 到 70 个字符",
                        trigger: "blur",
                    },
                ],

                companyName: [
                    {
                        min: 2,
                        max: 70,
                        message: "长度在 2 到 70 个字符",
                        trigger: "blur",
                    },
                ],
                deliveryTime: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur",
                    },
                ],
            },
            paymentRules: {
                paymentStatus: [
                    {
                        required: true,
                        message: "请选择支付状态",
                        trigger: "blur",
                    },
                ],

                billId: [
                    {
                        required: true,
                        message: "请选择关联流水",
                        trigger: "blur",
                    },
                ],
            },
            step: "b",
            width: 500,

            visibleBuyer: false,
            checkedBuyer: false,
            buyerParams: {},
            buyers: null,

            visibleAlibabaOrders: false,
            checkedAlibabaOrders: false,
            alibabaOrdersParams: {},
            alibabaOrders: null,

            orderGetUrl: ["factory/order/get", "factory/order/getMyself"],
            orderCancelUrl: ["factory/order/cancel", "factory/order/cancelMyself"],
            orderItemGetUrl: ["factory/order/item/get", "factory/order/item/getmyself"],
            orderItemAddUrl: ["factory/order/item/add", "factory/order/item/addmyself"],
            orderItemEditUrl: ["factory/order/item/update", "factory/order/item/updatemyself"],
            orderItemEditCostUrl: "factory/order/item/updateCost",
            orderItemDelUrl: ["factory/order/item/del", "factory/order/item/delmyself"],
            buyerPageUrl: ["alibaba/buyer/page", "alibaba/buyer/mypage"],
            buyerGetUrl: ["alibaba/buyer/get", "alibaba/buyer/getMyself"],
            alibabaOrdersGetUrl: ["alibaba/order/page", "alibaba/order/mypage"],

            colorVisible: false,
            colorValue: '',
            sizeVisible: false,
            sizeValue: '',

            suppliers: [],
            tabActive: {},
            defTabActive: '1',
            showBillDialog: false,
            peymentType: null,
            paymentRelateData1: null,
            paymentRelateData2: null,
        };
    },
    methods: {
        show(id, step) {
            this.title = "";
            this.order = {};
            this.orderItems = [];
            this.orderId = null;
            this.step = step ? step : "a";

            if (id) {
                this.orderId = id;

                if (this.step == "b") {
                    this.width = 500;
                    this.title = '修改生产单';
                    this.getBaseInfo(id);
                } else if (this.step == "c" || this.step == "d" || this.step == "m") {
                    this.width = 650;
                    this.title = '生产单明细';
                    this.getItemInfo(id);
                } else if (this.step == "e") {
                    this.width = 400;
                    this.title = '分配供应商';
                    this.getSupplier();
                } else if (this.step == 'i') {
                    this.cancelOrder();
                } else if (this.step == 'h') {
                    this.toEnd()
                } else if (this.step == 'f') {
                    this.width = 400;
                    this.title = '更新生产进度';
                    this.showDialog = true;
                } else if (this.step == 'g') {
                    this.width = 500;
                    this.title = '指定预计交付时间';
                    this.orderId = id;
                    this.showDialog = true;
                } else if (this.step == 'k' || step == 'l') {
                    this.width = 700;
                    this.title = '支付款项';
                    this.showPaymentInfo();
                } 
            } else {
                this.width = 500;
                this.title = '新建生产单';
                this.showDialog = true;
            }
        },
        getBaseInfo(id) {
            let _this = this;

            _this.$http.post(
                [_this.getUrl(_this.orderGetUrl), { id: id }],
                [
                    function (data) {
                        _this.order = data;
                        _this.showDialog = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        getItemInfo() {
            let _this = this;

            _this.orderItem = null;

            _this.$http.post(
                [_this.getUrl(_this.orderItemGetUrl), { orderId: _this.orderId }],
                [
                    function (data) {
                        for (var i in data) {
                            _this.numberJsonTArr(data[i]);
                        }

                        _this.orderItems = data;
                        _this.showDialog = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        getSupplier() {
            let _this = this;

            _this.$http.post(
                ["factory/supplier/all"],
                [
                    function (data) {
                        _this.suppliers = data;
                        _this.showDialog = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        refeshRule() {
            if (this.step == 'a' || this.step == 'b') {
                this.$refs["orderForm"].resetFields();
            } else if (this.step == 'k') {
                this.$refs["paymentForm"].resetFields();
            }
            
            this.$emit("update:showAdd", false);
        },
        preSave() {
            let _this = this;
            _this.$refs["orderForm"].validate().then(_this.dosave);
        },
        preSaveItem() {
            let _this = this;
            _this.$refs["orderItemForm"].validate().then(_this.doSaveItem);
        },
        dosave() {
            let _this = this;

            _this.$http.post(
                ["factory/order/create", _this.order],
                [
                    function (data) {
                        if (data.id) {
                            _this.order = data;

                            if (_this.orderId) {
                                _this.afterSave();
                            } else {
                                _this.afterSave();
                                _this.show(data.id, "c");
                            }
                        }
                    },
                ],
                ".order-add-dialog"
            );
        },
        editItem(item) {
            let _this = this;

            if (_this.orderItem) {
                _this.$message({
                    message: '当前有未保存的数据,请保存后再继续操作',
                    type: 'error'
                })
            } else {
                _this.initItemInfo(item);
            }
        },
        addEmptyItem() {
            let _this = this;
            _this.initItemInfo({ orderId: _this.orderId, mainImgBase: null});
            _this.orderItems.unshift(_this.orderItem);
        },
        cancelSeveItem() {
            this.getItemInfo();
        },
        delItem(item) {
            let _this = this;

            _this.$tConfirm.show("确定删除？", function() {
                if (item.id) {
                    _this.$http.post(
                        [_this.getUrl(_this.orderItemDelUrl), {id: item.id, orderId: item.orderId}],
                        [
                            function (data) {
                                 _this.getItemInfo();
                            },
                        ],
                        ".order-add-dialog"
                    );
                } else {
                    _this.getItemInfo();
                }
            })
        },
        initItemInfo(item) {
            if (item) {
                this.numberJsonTArr(item);
                this.orderItem = item;
            } else {
                this.orderItem = null;
            }
        },
        numberJsonTArr(item) {
            if (item.numbers) {
                item.colors = [];
                item.sizes = [];
                var numbers = typeof item.numbers == 'string'  ? JSON.parse(item.numbers) : item.numbers;

                let colorSet = new Set();
                let sizeSet = new Set();

                for (var i in numbers) {
                    if (!colorSet.has(numbers[i].color)) {
                        colorSet.add(numbers[i].color);
                        item.colors.push(numbers[i].color);
                    }

                    if (!sizeSet.has(numbers[i].size)) {
                        sizeSet.add(numbers[i].size);
                        item.sizes.push(numbers[i].size);
                    }
                }

                for (var i in numbers) {
                    numbers[i].rowspan = sizeSet.size;
                }

                item.numbers = numbers;
                item.mainImgBase = null;
                item.colorImgBase = null;
                item.packImgBase = null;
                item.trademarkImgBase = null;
                item.percent = 0;
            } else {
                item.colors = [];
                item.sizes = [];
                item.numbers = [];
                item.mainImgBase = null;
                item.colorImgBase = null;
                item.packImgBase = null;
                item.trademarkImgBase = null;
                item.percent = 0;
            }
        },
        uploadedCallbackMainImg(files, file) {
            this.orderItem.mainImg = null;
            this.orderItem.percent = 0;

            if  (file) {
                this.orderItem.mainImgBase = file.base64
                this.orderItem.mainImgFile = file;
            } else {
                this.orderItem.mainImgBase = null;
                this.orderItem.mainImgFile = null;
                
            }
        },
        uploadedCallbackColorImg(files, file) {
            this.orderItem.colorImg = null;
            this.orderItem.percent = 0;

            if (file) {
                this.orderItem.colorImgBase = file.base64
                this.orderItem.colorImgFile = file;
            } else {
                this.orderItem.colorImgBase = null;
                this.orderItem.colorImgFile = null;
                
            }
        },
        uploadedCallbackPackImg(files, file) {
            this.orderItem.packImg = null;
            this.orderItem.percent = 0;

            if (file) {
                this.orderItem.packImgBase = file.base64
                this.orderItem.packImgFile = file;
            } else {
                this.orderItem.packImgBase = null;
                this.orderItem.packImgFile = null;
                
            }
        },
        uploadedCallbackTrademarkImg(files, file) {
            this.orderItem.trademarkImg = null;
            this.orderItem.percent = 0;

            if (file) {
                this.orderItem.trademarkImgBase = file.base64
                this.orderItem.trademarkImgFile = file;
            } else {
                this.orderItem.trademarkImgBase = null;
                this.orderItem.trademarkImgFile = null;
            }
        },
        progressCallback(evel){

            this.orderItem.percent = window.parseInt(evel.percent);
        },
        colorSpanMethod({ row, column, rowIndex, columnIndex }) {
            var size = this.orderItem ? this.orderItem.sizes.length : row.rowspan;

            if (columnIndex == 0 && size > 1) { 
                if (rowIndex % size == 0) {
                    return [size, 1]
                } else {
                    return [0, 0]
                }
            }
        },
        preSaveItem() {
            if (!this.orderItem.name || !this.orderItem.code) {
                this.$message({
                    message: '名称、型号、主图均不能为空',
                    type: 'error'
                })
            } else {
               this.doSaveItem();
            }
        },
        doSaveItem() {
            let _this = this;

            _this.$http.post(
                [_this.orderItem.id ? _this.getUrl(_this.orderItemEditUrl) : _this.getUrl(_this.orderItemAddUrl), _this.orderItem],
                [
                    function (data) {
                        _this.getItemInfo();
                    },
                ],
                ".order-add-dialog"
            );

        },
        afterSave() {
            this.showDialog = false;

            if (this.actionFuc) {
                this.actionFuc();
            }
        },
        pageBuyer() {
            let _this = this;

            _this.checkedBuyer = false;

            _this.$http.post(
                [_this.getUrl(_this.buyerPageUrl), _this.buyerParams],
                [
                    function (data) {
                        _this.buyerParams.total = data.total;
                        _this.buyers = data.records;
                        
                        _this.visibleBuyer = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        getAlibabaOrder() {
            let _this = this;

            _this.checkedAlibabaOrders = false;

            _this.$http.post(
                [_this.getUrl(_this.alibabaOrdersGetUrl), _this.alibabaOrdersParams],
                [
                    function (data) {
                        _this.alibabaOrdersParams.total = data.total;
                        _this.alibabaOrders = data.records;
                        
                        _this.visibleAlibabaOrders = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        seleteBuyer(buyer) {
            this.order.buyer = buyer.id;
            this.order.fullName = buyer.fullName;
            this.order.companyName = buyer.companyName;
            this.visibleBuyer = false;
            this.checkedBuyer = false;
        },
        seleteAlibabaOrders(alibabaOrder) {
            let _this = this;
            _this.order.alibabaOrder = alibabaOrder.id;
            _this.order.buyer = alibabaOrder.buyer;

            _this.$http.post(
                [_this.getUrl(_this.buyerGetUrl), {id: alibabaOrder.buyer}],
                [
                    function (data) {
                        _this.order.fullName = data.fullName;
                        _this.order.companyName = data.companyName;
                        _this.visibleAlibabaOrders = false;
                        _this.checkedAlibabaOrders = false;
                    },
                ],
                ".order-add-dialog"
            );
        },
        updateSupplier() {
            let _this = this;

            _this.$http.post(
                ["factory/order/updateSupplier", {id: _this.orderId, supplier: _this.order.supplier}],
                [
                    function (data) {
                        _this.afterSave();
                    },
                ],
                ".order-add-dialog"
            );
        },
        cancelOrder() {
            let _this = this;

            _this.$tConfirm.show("确认取消订单？", function() {
                _this.$http.post(
                    [_this.getUrl(_this.orderCancelUrl), {id: _this.orderId}],
                    [
                        function (data) {
                            _this.afterSave();
                        },
                    ],
                    ".order-add-dialog"
                );
            })
        },
        toEnd() {
            let _this = this;

            _this.$tConfirm.show("确认完成订单？", function() {
                _this.$http.post(
                    ["factory/order/toEnd", {id: _this.orderId}],
                    [
                        function (data) {
                            _this.afterSave();
                        },
                    ],
                    ".order-add-dialog"
                );
            })
        },
        saveProgress() {
            let _this = this;

            _this.$http.post(
                ["factory/order/item/updateProgress", {id: _this.orderItem.id, numbers: _this.orderItem.numbers, orderId: _this.orderItem.orderId}],
                [
                    function (data) {
                        _this.getItemInfo();
                    },
                ],
                ".order-add-dialog"
            );
        },
        toProduct(id) {
            let _this = this;

            _this.$http.post(
                ["factory/order/confirm", {id: _this.orderId},  _this.order],
                [
                    function (data) {
                        _this.afterSave();
                    },
                ],
                ".order-add-dialog"
            );
        },
        upProductStatus() {
            let _this = this;

            _this.$http.post(
                ["factory/order/updateProductStatus", {id: _this.orderId},  _this.order],
                [
                    function (data) {
                        _this.afterSave();
                    },
                ],
                ".order-add-dialog"
            );
        },
        preSavePayment() {
            let _this = this;
            _this.$refs["paymentForm"].validate().then(_this.savePayment);
        },
        savePayment() {
        },
        showPaymentInfo() {
            let _this = this;

            _this.$http.post(
                ["factory/order/getPaymentInfo", {id: _this.orderId}],
                [
                    function (data) {
                        if (data) {
                            _this.paymentRelateData1 = data.DOWN;
                            _this.paymentRelateData2 = data.BALANCE;
                        }

                        _this.showDialog = true;
                    },
                ],
                ".order-add-dialog"
            );
        },
        raltePyment(type) {
            this.order.paymentStatus = type;
            this.showBillDialog = true;
        },
        afterSeleted(ids, datas)  {
            let _this = this;

            _this.$http.post(
                ["factory/order/updatePayment", {id: _this.orderId, billId: ids, paymentStatus: _this.order.paymentStatus}],
                [
                    function (data) {
                        _this.showPaymentInfo();
                    },
                ],
                ".order-add-dialog"
            );
        },
        cancelPayment(orderId, billid, type)  {
            let _this = this;

            _this.$tConfirm.show("确定取消关联？", function() {
                _this.$http.post(
                    ["factory/order/cancelPayment", {id: orderId, billId: billid, paymentStatus: type}],
                    [
                        function (data) {
                            _this.showPaymentInfo();
                        },
                    ],
                    ".order-add-dialog"
                );
            });
        },
        preSaveItemCost() {
            let _this = this;

            _this.$http.post(
                [_this.orderItemEditCostUrl, {id: _this.orderItem.id, numbers : _this.orderItem.numbers, orderId: _this.orderItem.orderId}],
                [
                    function (data) {
                        _this.getItemInfo();
                    },
                ],
                ".order-add-dialog"
            );
        },
        exportItem() {
            window.open("/api/factory/order/item/export?orderId=" + this.orderId, "_blank");
        },

        /** =============================工具方法 ================================*/
        getUrl(url) {
            return url[this.isRoot ? 0 : 1];
        },
        canSave(item) {
            return (!item.id || (this.orderItem && item.id == this.orderItem.id)) && this.step == 'c'
        },
        canSaveCost(item) {
            return this.canSave(item) || this.step == 'm';
        },
        getUnitName(key)  {
            for (var i in this.units) {
                if (this.units[i].id == key) {
                    return this.units[i].name;
                }
            }
            return key;
        },
        handleColorClose(item, color) {
            item.colors.splice(item.colors.indexOf(color), 1);
            this.handleNumber(item);
        },
        showColorInput(item) {
            this.colorVisible = true;

            this.$nextTick(_ => {
                this.$refs["color-" + item.id][0].$refs.input.focus();
            });
        },
        handleColorConfirm(item) {
            let colorValue = this.colorValue;

            if (colorValue) {
                item.colors.push(colorValue);
                this.handleNumber(item);
            }

            this.colorVisible = false;
            this.colorValue = '';
        },

        handleSizeClose(item, size) {
            item.sizes.splice(item.sizes.indexOf(size), 1);
            this.handleNumber(item);
        },
        showSizeInput(item) {
            this.sizeVisible = true;

            this.$nextTick(_ => {
                this.$refs["size-" + item.id][0].$refs.input.focus();
            });
        },
        handleSizeConfirm(item) {
            let sizeValue = this.sizeValue;

            if (sizeValue) {
                item.sizes.push(sizeValue);
                this.handleNumber(item);
            }

            this.sizeVisible = false;
            this.sizeValue = '';
        },
        handleNumber(item) {
            let colors = item.colors && item.colors[0] ? item.colors : ["默认颜色"];
            let sizes = item.sizes && item.sizes[0]  ? item.sizes : ["默认尺寸"];
            let numbers = JSON.parse(JSON.stringify(item.numbers));

            item.numbers.splice(0, item.numbers.length);

            for (var c in colors) {
                for (var s in sizes) {
                    item.numbers.push({
                        color: colors[c],
                        size: sizes[s],
                        number: this.getNumberCache(numbers, colors[c], sizes[s])
                    });
                }
            }
        },
        getNumberCache(numbers, c, s) {
            for (var i in numbers) {
                if (numbers[i].color == c && numbers[i].size == s) {
                    return numbers[i].number;
                }
            }
            return 0;
        },
        getSkuTotal()  {
            let total = 0;
            let numbers = null;

            for (var i in this.orderItems) {
                if (this.orderItems[i].numbers) {
                    numbers = this.orderItems[i].numbers;

                    for (var j in numbers) {
                        total += numbers[j].number ? numbers[j].number : 0;
                    }
                }
            }

            return total;
        },
        getSkuCost() {
            let total = 0;
            let numbers = null;

            for (var i in this.orderItems) {
                if (this.orderItems[i].numbers) {
                    numbers = this.orderItems[i].numbers;

                    for (var j in numbers) {
                        total += numbers[j].number && numbers[j].cost ? numbers[j].number * numbers[j].cost : 0;
                    }
                }
            }

            return new Number(total.toFixed(2));
        }
    },
};
</script>